const filters = document.querySelectorAll('.food-filter');
const foods = document.querySelectorAll('.foods-overview .nutrient-tile');

filters.forEach((filter) => {
  filter.addEventListener('click', (event) => {
    event.preventDefault();
    filters.forEach((filter) => filter.classList.remove('active'));
    filter.classList.add('active');
    foods.forEach((food) => (food.hidden = false));
    const category = filter.dataset.category;
    if (!category) {
      return;
    }
    foods.forEach((food) => {
      if (food.dataset.category !== category) {
        food.hidden = true;
      }
    });
  });
});
